import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useSlideErrors} from '../../../../context/SlideErrorsContext';
import {TabType} from '../../../../components/slides/form/part/tabs';
import Button, {ButtonColorType} from '../../../../incase-domain/components/button/Button';
import {AppState} from '../../../../store/reducer';
import {highlightedElementAtIndex} from '../../../../store/selectors/selector.utils';

interface TabProps {
    tab: TabType;
    onClick?: () => void;
    active: boolean;
}

export default function Tab({tab, onClick, active}: Readonly<TabProps>): JSX.Element {
    const {t} = useTranslation();
    const {checkTabError} = useSlideErrors();
    const selectedElement = useSelector((state: AppState) => highlightedElementAtIndex(state));
    const isError = checkTabError(tab, selectedElement);

    const getColor = (): ButtonColorType => {
        if (isError) {
            return 'error';
        }
        return active ? 'secondary' : 'primary';
    };

    return (
        <Button
            className="c-tab"
            fullWidth
            variant={active ? 'soft' : 'ghost'}
            size="sm"
            color={getColor()}
            leading={isError ? 'solar:danger-triangle-bold' : ''}
            onClick={onClick}
        >
            {t(tab.label)}
        </Button>
    );
}
